import React from 'react';

const wallets = [
  {
    id: 'metamask',
    name: 'MetaMask',
    description: 'Connect with MetaMask browser extension',
  },
  {
    id: 'walletconnect',
    name: 'WalletConnect',
    description: 'Connect any wallet via QR code',
  },
  {
    id: 'tokenpocket',
    name: 'TokenPocket',
    description: 'Mobile & browser wallet',
  },
  {
    id: 'trustwallet',
    name: 'Trust Wallet',
    description: 'Trusted mobile wallet',
  },
];

const WalletSelectModal = ({ open, onClose, onSelect }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-primary/80 backdrop-blur-sm p-4 animate-fadeInModal">
      <style>{`
        @keyframes fadeInModal {
          from { opacity: 0; transform: scale(0.97); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fadeInModal {
          animation: fadeInModal 0.25s ease-out;
        }
      `}</style>

      {/* Modal container */}
      <div className="w-full max-w-[95vw] sm:max-w-sm md:max-w-md bg-primary border border-primary/30 rounded-2xl shadow-2xl p-6 sm:p-8 flex flex-col items-center gap-5 relative">
        {/* Close button */}
        <button
          className="absolute top-3 right-3 text-2xl text-light hover:text-secondary focus:outline-none"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>

        {/* Icon */}
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-light text-primary mb-2">
          {/* Replace with a wallet icon */}
          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </div>

        {/* Title */}
        <h2 className="text-lg sm:text-xl font-bold text-center text-light tracking-wide">
          Select a Wallet
        </h2>

        {/* Wallet options */}
        <div className="w-full flex flex-col gap-3 mt-2">
          {wallets.map((w) => (
            <button
              key={w.id}
              className="w-full flex flex-col items-start px-4 py-3 rounded-xl border border-primary/30 bg-light hover:bg-primary/10 transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-light"
              onClick={() => onSelect(w.id)}
            >
              <span className="font-semibold text-base text-primary">{w.name}</span>
              <span className="text-xs mt-0.5 text-secondary">{w.description}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WalletSelectModal;